"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var WheelBlockSticky = function () {
    var _a, _b, _c;
    var t = (0, next_intl_1.useTranslations)('wheel');
    var _d = (0, swr_hooks_1.useGetWheel)(), data = _d.data, isLoading = _d.isLoading;
    var openWheel = (0, apps_shared_1.useOpenWheel)();
    var endDate = ((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.nextSpinDate) && new Date((_b = data === null || data === void 0 ? void 0 : data[0]) === null || _b === void 0 ? void 0 : _b.nextSpinDate);
    var currentDate = new Date();
    var isNextSpinDateFuture = currentDate < endDate;
    if (isLoading || !((_c = data === null || data === void 0 ? void 0 : data[0]) === null || _c === void 0 ? void 0 : _c.ticketsAmount) || isNextSpinDateFuture)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.sticky, onClick: openWheel },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.gradient }),
        react_1.default.createElement("span", null, t('spinWheel')),
        react_1.default.createElement("img", { className: styles_module_scss_1.default.wheel, src: "/img/wheel/stickyWheel.png", alt: "stickyWheel" }),
        react_1.default.createElement("img", { className: styles_module_scss_1.default.wheelWrap, src: "/img/wheel/stickyWheelWrap.png", alt: "stickyWheelWrap" })));
};
exports.default = WheelBlockSticky;
